import Api from '@/api'

const state = {
    items: [],
    pageNo: 1,
    pageSize: 10,
    totalCount: 0,
    totalPage: 1
}
const getters = {
    robots: state => state.items,
    rPageNo: state => state.pageNo,
    rPageSize: state => state.pageSize,
    rTotalCount: state => state.totalCount,
    rTotalPage: state => state.totalPage
}
const mutations = {}
const actions = {
    async loadRobots({state}, params) {
        let {data} = await Api.robotList(params);
        let {items, pageNo, pageSize, totalPage, totalCount} = data;
        state.items = items;
        state.pageNo = pageNo;
        state.totalPage = totalPage;
        state.totalCount = totalCount;
    },
    async robotSave({state}, params) {
        return await Api.robotSave(params);
    }
}
export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/components/robot_store.js